import { AuthService } from './../user/auth.service';
import { RegistryService } from './../registry/registry.service';
import { RegistryFirebaseService } from './../registry/registry-firebase.service';
import { Component, OnInit } from '@angular/core';
import { FormGroup, FormArray, FormBuilder, Validators } from '@angular/forms';
import { CustomValidatorsService } from '../shared/validators.service';
import { Settings } from '../settings/settings';
import { Contribution } from '../track/contribution';
import { ActivatedRoute } from '@angular/router';
import { Gift } from '../gift/gift';
import { Registry } from '../registry/registry';
import { UserService } from '../user/user.service';

@Component({
  selector: 'app-account-notifications',
  templateUrl: './account-notifications.component.html',
  styleUrls: ['./account-notifications.component.scss']
})
export class AccountNotificationsComponent implements OnInit {

  public settings: Settings;
  registry: Registry;
  contributions: Contribution[];
  gifts: Gift[];
  public hitchdForm: FormGroup;
  private valueChanged = false;
  loaded = false;

  processing = false;
  constructor(
    private _fb: FormBuilder,
    private _validatorService: CustomValidatorsService,
    private _registryFirebaseService: RegistryFirebaseService,
    private _registryService: RegistryService,
    private _authService: AuthService,
    private route: ActivatedRoute,
    private _userService: UserService
  ) {

    document.title = 'Account | Hitchd';
    this._authService.user.subscribe(user => {

      this._registryFirebaseService.initGiftsForUser(user);
    });

  }

  ngOnInit() {
    this._registryService.setScrollY(1);
    this.registry = this.route.snapshot.data.registry;
    this.contributions = this.route.snapshot.data.contributions;

    this.settings = this.route.snapshot.data.settings;

    this.hitchdForm = this._fb.group({
      emailGuestPays: ['', [Validators.required]],
      emailUpdates: ['', [Validators.required]],
      emailWhenRsvpReceived: ['', [Validators.required]],
    });
    this.load();

    this._registryFirebaseService.killLoader();
  }



  load() {


    this.contributions = this.route.snapshot.data.contributions;
    this.gifts = this.route.snapshot.data.gifts;
    this._registryFirebaseService.getContributions(this.gifts).subscribe(contribution => {

      this.contributions = contribution;
    });

    this._registryFirebaseService.currentSettings.subscribe(
      response => {

        this.settings = response;
        //
        if (this.settings) {
          this.hitchdForm.controls['emailWhenRsvpReceived'].setValue(response.emailWhenRsvpReceived);
          this.hitchdForm.controls['emailGuestPays'].setValue(response.emailGuestPays);
          this.hitchdForm.controls['emailUpdates'].setValue(response.emailUpdates);
        }
        this.loaded = true;
      });
  }
  handleLoaded(){


  }

  openMobileMenu() {
    this._userService.emitUpdateHeaderType('showMobileMenu');
  }
  save() {

    this.processing = true;
    if (!this.settings) {
      this.settings = new Settings();
    }
    this.settings.emailGuestPays = this.hitchdForm.controls['emailGuestPays'].value;
    this.settings.emailUpdates = this.hitchdForm.controls['emailUpdates'].value;
    this.settings.emailWhenRsvpReceived = this.hitchdForm.controls['emailWhenRsvpReceived'].value;
    
    this._registryFirebaseService.saveSettings(this.settings);

    setTimeout(() => {
      this.processing = false;
    }, 1 * 1000);
    this.valueChanged = false;
  }

  makeSelection(controlName: string, value: boolean) {
    this.hitchdForm.controls[controlName].setValue(value);
    this.valueChanged = true;
  }
}



// WEBPACK FOOTER //
// ./src/app/account-notifications/account-notifications.component.ts